// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const TooltipIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13">
            <path
                fill="currentColor"
                d="M6,0 C2.68593764,0 0,2.68593764 0,6 C0,9.31406236 2.68593764,12 6,12 C9.31406236,12 12,9.31406236 12,6 C12,2.68593764 9.31406236,0 6,0 Z M6,9.375 C5.578125,9.375 5.25,9.046875 5.25,8.625 C5.25,8.203125 5.55703139,7.875 6,7.875 C6.40078139,7.875 6.75,8.203125 6.75,8.625 C6.75,9.046875 6.40078139,9.375 6,9.375 Z M7.61953139,6.046875 L6.5625,6.703125 L6.5625,6.75 C6.5625,7.0546875 6.3046875,7.3125 6,7.3125 C5.6953125,7.3125 5.4375,7.0546875 5.4375,6.75 L5.4375,6.375 C5.4375,6.1875 5.53125,6 5.71875,5.8828125 L7.0546875,5.0859375 C7.21875,4.9921875 7.3125,4.828125 7.3125,4.640625 C7.3125,4.359375 7.05703139,4.125 6.77578139,4.125 L5.578125,4.125 C5.27578139,4.125 5.0625,4.359375 5.0625,4.640625 C5.0625,4.9453125 4.8046875,5.203125 4.5,5.203125 C4.1953125,5.203125 3.9375,4.9453125 3.9375,4.640625 C3.9375,3.7265625 4.6640625,3 5.55703139,3 L6.75468779,3 C7.7109375,3 8.4375,3.7265625 8.4375,4.640625 C8.4375,5.203125 8.1328125,5.7421875 7.61953139,6.046875 Z"
                opacity="1"
                transform="translate(0 .5)"
            />
        </svg>
    );
};

export default React.memo(TooltipIcon);
